import { usePremadeQuizzes } from '@quizzach/api-hooks';
import { Navigation, QuizGrid } from '@quizzach/components';
import { Reveal } from '@quizzach/motion';
import { PhHead, PremadePage } from '@quizzach/styles';
import { scrollToTop } from '@quizzach/utils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const PremadeQuizzesAuthor = () => {
	const { t } = useTranslation();
	const { premadeQuizzes, loading, error, getPremadeQuizzes } =
		usePremadeQuizzes();

	useEffect(() => {
		getPremadeQuizzes();
		scrollToTop();
	}, []);

	return (
		<PremadePage>
			<Navigation />

			<PhHead>
				<Reveal as='h1'>
					{t('premade.sections.authorsTitle')}
					<br />
					<em>{t('premade.sections.authorsSubtitle')}</em>
				</Reveal>
			</PhHead>

			<QuizGrid quizzes={premadeQuizzes} loading={loading} error={error} />

			<div style={{ paddingBottom: '130px' }} />
		</PremadePage>
	);
};
